import * as React from 'react';
import { capitalize, get, isEmpty } from 'lodash';
import TerraformConsoleOutputModal from './TerraformConsoleOutputModal';

import {
  ExecutionDetailsSection,
  IExecutionDetailsSectionProps,
  StageFailureMessage,
} from '@spinnaker/core';

const planResultText: { [key: string]: string } = {
    '0': 'Succeeded, diff is empty (no changes)',
    '1': 'Errored',
    '2': 'Succeeded, there is a diff',
};

export class TerraformExecutionDetails extends React.Component<IExecutionDetailsSectionProps> {
  public static title = 'terraformStatus';

  public render() {
    const { current, name, stage } = this.props;
    const { context, outputs } = stage;
    const terraformVersion = get(context, ['terraformVersion']);
    const workspace = get(context, ['workspace'], '');
    const targets = get(context, ['targets'], []);
    const overrides = get(context, ['overrides'], {});
    const jobId = get(outputs, ['status', 'id'], '');
    const errorMessage = get(outputs, ['status', 'error'], '');
    const exitCode = get(outputs, ['status', 'code'], null);
    const state = get(outputs, ['status', 'state'], '');
    return (
      <ExecutionDetailsSection name={name} current={current}>
        <div>
          <dl className="dl-narrow dl-horizontal">
            <dt>Version</dt>
            <dd>{terraformVersion}</dd>
            <dt>Action</dt>
            <dd>{capitalize(context.action)}</dd>
            { exitCode != null && context.action === 'plan' && state === 'COMPLETE' && (
              <>
                <dt>Result</dt>
                <dd>{get(planResultText, [exitCode], '')}</dd>
              </>
            )}
            { context.planForDestroy && context.action === 'plan' && (
              <>
                <dt>Plan for Destroy</dt>
                <dd>{context.planForDestroy.toString()}</dd>
              </>
            )}
            { (context.action === 'apply' || context.action === 'destroy') && context.lock && (
              <>
                <dt>Ignore Locking</dt>
                <dd>{context.lock.toString()}</dd>
              </>
            )}
            { context.dir && (
              <>
                <dt>Subdirectory</dt>
                <dd>{context.dir}</dd>
              </>
            )}
            { workspace && (
              <>
                <dt>Workspace</dt>
                <dd>{workspace}</dd>
              </>
            )}
            { targets.length > 0 && (
              <>
                <dt>Targets</dt>
                {targets.map(t => (<dd>{t}</dd>))}
              </>
            )}
            { !isEmpty(overrides) && (
              <>
                <dt>Variables</dt>
                { Object.entries(overrides).map(([key, value]) => (
                  <dd>{key}={value.toString()}</dd>
                ))}
              </>
            )}
            <dt>Logs</dt>
            <dd>
              <TerraformConsoleOutputModal
                jobStatus={state}
                jobId={jobId}
                linkName="Console Output"
                modalTitle={`Terraform ${capitalize(context.action)} Output`}
              />
            </dd>
          </dl>
        </div>
        <StageFailureMessage stage={stage} message={errorMessage || stage.failureMessage} />
      </ExecutionDetailsSection>
    );
  }
}
